import { QGetSettings } from "./QGetSettings";
import { QSaveSettings } from "./QSaveSettings";
import { QGetWageringInformation } from "./QGetWageringInformation";
export const QueryBuilder = {
    getSettings: QGetSettings,
    saveSettings: QSaveSettings,
    getWageringInformation: QGetWageringInformation
};
//# sourceMappingURL=index.js.map